"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      tabName: {},
      tab: [],
      listLoading: false,
      listQuery: {
        cate_id: '1',
        start: 1,
        limit: 20,
        page_num: 1
      },
      tableMaxH: '250',
      editDialog: false,
      editForm: {},
      form: {},
      list: [{
        0: 0
      }]
    };
  },
  mounted: function mounted() {
    this.getCates();
  },
  methods: {
    /**
     * 获取类别
     */
    getCates: function getCates() {
      var _this = this;
      this.$get('agentapi/article/helping_thread_cates').then(function (res) {
        var tabName = {};
        res.map(function (item) {
          tabName[item.cate_id] = item.cate_name;
        });
        _this.tab = res;
        _this.tabName = tabName;
        if (res.length > 0) _this.listQuery.cate_id = res[0].cate_id.toString();
        _this.getList();
      });
    },
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.listQuery.order_type = tab.name;
      this.listQuery.start = 1;
      this.getList();
    },
    /**
       * 搜索查询
       */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
        this.listQuery.limit = 10;
      } else {
        if (this.cat_id && this.cat_id.length > 0) {
          this.form.cat_id = this.cat_id[this.cat_id.length - 1];
        }
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this2 = this;
      var params = Object.assign({}, this.listQuery, {
        start: this.listQuery.start - 1,
        page: 1
      });
      this.$get('agentapi/article/helping_thread_list', params).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.list;
        _this2.listQuery.page_num = res.page_num;
        _this2.tableMaxH = window.innerHeight - _this2.$refs.list_table.$el.offsetTop - 85;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    onSubmit: function onSubmit(formName) {
      var _this3 = this;
      var url = 'agentapi/system/save_articles',
        form = JSON.parse(JSON.stringify(this.form)),
        params = {
          articel_type: this.articel_type
        };
      for (var i in form) {
        params["content_".concat(this.articel_type, "_").concat(form[i].cat_id)] = form[i].content;
      }
      // 【操作埋点】2026-05-25 pc_setting_update_1 帮助文章批量保存
      this.$post(url, params).then(function (res) {
        _this3.$settingReport.reportSettingUpdate('save_articles', '帮助文章批量保存', null, params);
        _this3.$message({
          message: '提交成功',
          type: 'success'
        });
      });
    },
    /**
     * 删除文章
     */
    del: function del(row, index) {
      var _this4 = this;
      this.$alert('确定删除吗？', '删除文章', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            // 【操作埋点】2026-05-25 pc_setting_update_1 删除帮助问题
            _this4.$post('agentapi/article/helping_thread_del', {
              id: row.id
            }).then(function (res) {
              _this4.$settingReport.reportSettingUpdate('helping_thread_del', '删除帮助问题', {
                id: row.id,
                title: row.title,
                content: row.content
              }, null);
              _this4.$message({
                message: '删除成功',
                type: 'success'
              });
              _this4.list.splice(index, 1);
            });
          }
        }
      });
    },
    /**
     * 提交保存文章
     */
    save: function save() {
      var _this5 = this;
      var params = {},
        editForm = this.editForm;
      params.title = editForm.title;
      params.content = editForm.content;
      params.cate_id = editForm.cate_id;
      if (editForm.id) params.id = editForm.id;

      // 【操作埋点】2026-05-25 pc_setting_update_1 新增/编辑帮助问题
      this.$post('agentapi/article/helping_thread_save', params).then(function (res) {
        _this5.$settingReport.reportSettingUpdate('helping_thread_save', editForm.id ? '编辑帮助问题' : '新增帮助问题', null, params);
        _this5.$message({
          message: '提交成功',
          type: 'success'
        });
        _this5.editDialog = false;
        _this5.getList();
      });
    }
  }
};